import { MAX_FILE_UPLOAD_SIZE } from 'app/config/config';
import GoogleDrivePicker from 'core/utils/GooglePicker/GoogleDrivePicker';
import PropTypes from 'prop-types';
import React from 'react';
import AuthProviderButton from 'ui/molecules/AuthProviderButton/AuthProviderButton';
import DialogUploadFile from 'ui/organisms/dialogs/DialogUploadFile/DialogUploadFile';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';
import Loading from 'ui/atoms/Loading/Loading';
import AttachmentCard from 'core/modules/components/cards/AttachmentCard';

import useDialogAddContent from './useDialogAddContent';

const DialogAddContent = ({ open, course, onClose, title, item, onChangeMedia, type_content }) => {
  const {
    t,
    acceptedExtensions,
    isSuccessDisabled,
    isUploadingContent,
    attachedFiles,
    onChangeFiles,
    percentage,
    onCreate,
    onChangeNameContent,
    onAuthFailed,
    onChangeGooglePicker,
    driveInfo,
    onRemoveDrive,
  } = useDialogAddContent({
    itemGuid: item.id,
    onChangeMedia,
    onClose,
    course,
    type_content,
  });

  const driveCard = driveInfo?.doc ? (
    <div className="dialog-add-content__content-drive-card">
      <AttachmentCard guid={driveInfo.doc.id} type={driveInfo.doc.type} title={driveInfo.doc.name} onDelete={onRemoveDrive} />
    </div>
  ) : null;

  const googleDriveActions =
    !driveInfo?.doc && attachedFiles.length === 0 ? (
      <div className="dialog-add-content__buttons">
        <GoogleDrivePicker text={t('common:Sign in with Google')} onChangeGooglePicker={onChangeGooglePicker} onAuthFailed={onAuthFailed}>
          <div className="dialog-add-content__google-drive">
            <div className="dialog-add-content__google-drive-text">{t('common:Upload file from Google drive')}</div>
            <AuthProviderButton provider="google" text={t('common:Sign in with Google')} />
          </div>
        </GoogleDrivePicker>
      </div>
    ) : null;

  return (
    <>
      {isUploadingContent && <Loading />}
      <DialogUploadFile
        acceptedExtensions={acceptedExtensions}
        buttonTextSuccess={t('actions:Add')}
        className="dialog-add-content"
        extraActions={googleDriveActions}
        isMultiple={false}
        isOpen={open && driveInfo?.status !== 'loaded'}
        isSuccessDisabled={isSuccessDisabled}
        isUploadAreaHidden={Boolean(driveInfo?.doc)}
        isUploading={isUploadingContent}
        maxSizeBytes={MAX_FILE_UPLOAD_SIZE * 1024 * 1024}
        onChangeFiles={onChangeFiles}
        onClose={onClose}
        onSuccess={onCreate}
        title={title}
        uploadProgress={percentage}
      >
        <FormField label={t('common:Title')}>
          <InputText placeholder={t('lesson:Title of content')} onChange={onChangeNameContent} />
        </FormField>
        {driveCard}
      </DialogUploadFile>
    </>
  );
};

DialogAddContent.propTypes = {
  course: PropTypes.object,
  item: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
  onChangeMedia: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  type_content: PropTypes.string,
};

DialogAddContent.defaultProps = {
  onClose: function () {},
  open: false,
};

export default DialogAddContent;
